<template>
  <div class="switch">
    <el-switch v-model="open" :active-color="activeColor || `#13ce66`" :active-value="activeValue || '0'"
      :inactive-value="inactiveValue || '1'" :class="(open === (activeValue || '0')) ? 'active' : 'inactive'"
      :disabled="disabled" @change="onToggle(data)">
    </el-switch>
  </div>
</template>

<script>
export default {
  name: "MySwitch",
  props: {
    keyName: String,
    activeColor: String,
    activeValue: [String, Number],
    inactiveValue: [String, Number],
    data: Object,
    disabled: Boolean,
  },
  data() {
    return {
      open: '0',
    };
  },
  // watch: {
  //   data: {
  //     deep: true,
  //     handler(newVal) {
  //       console.log(newVal)
  //     },
  //   },
  // },
  methods: {
    onToggle(data) {
      this.$emit('onToggle', data)
    },
  },
  mounted() {
    // console.log(this.data)
    this.open = this.data[this.keyName || 'open']
  },
};
</script>

<style lang="less" scoped>
.switch {
  /deep/.el-switch {
    &.inactive {
      .el-switch__core::after {
        content: '否';
        line-height: 17px;
        text-indent: 18px;
        color: #fff;
      }
    }

    &.active {
      .el-switch__core::after {
        content: '是';
        line-height: 17px;
        text-indent: -34px;
        color: #fff;
      }
    }
  }
}
</style>
